import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useArStatementEmail() {
  const queryClient = useQueryClient();

  const sendMutation = useMutation(
    orpc.accountsReceivable.arStatementEmail.send.mutationOptions({
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: orpc.accountsReceivable.arCustomerProfile.get.key(),
        });
      },
    }),
  );

  const previewMutation = useMutation(
    orpc.accountsReceivable.arStatementEmail.preview.mutationOptions(),
  );

  return {
    send: sendMutation.mutateAsync,
    isSending: sendMutation.isPending,
    preview: previewMutation.mutateAsync,
    isPreviewing: previewMutation.isPending,
    previewData: previewMutation.data ?? null,
    resetPreview: previewMutation.reset,
  };
}
